import { api } from '../api';

export const deleteAvatarImage = async (userId: string): Promise<void> => {
  await api.patch('/users/avatar', { userId });
};
